import { defineWsRoute, event } from "@bigswiss-gmbh/fast-ws";
import { AppDispatch } from "store";
import { setPaymentId, setPaymentStatus, setReceiptStatus, setActivationProgress, setError } from "store/payment/paymentReducer";


// Backend WS path is /ws/payments (see FastAPI ws_payments.py). Prefix is registered as "/payments".
// This route mirrors the identityRoute pattern and dispatches minimal actions into the payment slice.
export const paymentsRoute = defineWsRoute([
  // paymentStatus → { status, paymentId?, message? }
  event("paymentStatus", (data: any, dispatch: AppDispatch) => {
    try {
      if (data && typeof data === "object") {
        if ("status" in data) {
          dispatch(setPaymentStatus(String((data as any).status)));
        }
        if (data.paymentId) {
          dispatch(setPaymentId(String(data.paymentId)));
        }
      }
    } catch (err) {
      console.debug("[ws:payment] paymentStatus dispatch error", err);
    }
  }),

  // receiptStatus → { status, receiptId?, invoiceId? }
  event("receiptStatus", (data: any, dispatch: AppDispatch) => {
    try {
      if (data && typeof data === "object") {
        dispatch(setReceiptStatus({ status: String((data as any).status || ""), receiptId: (data as any).receiptId, invoiceId: (data as any).invoiceId }));
      }
    } catch (err) {
      console.debug("[ws:payment] receiptStatus dispatch error", err);
    }
  }),

  // activationProgress → { step, percent?, details? }
  event("activationProgress", (data: any, dispatch: AppDispatch) => {
    try {
      if (data && typeof data === "object") {
        const step = String((data as any).step || "");
        const percent = typeof (data as any).percent === "number" ? (data as any).percent : undefined;
        const details = (data as any).details;
        dispatch(setActivationProgress({ step, percent, details }));
      }
    } catch (err) {
      console.debug("[ws:payment] activationProgress dispatch error", err);
    }
  }),

  // error → { code, message }
  event("error", (data: any, dispatch: AppDispatch) => {
    try {
      if (data && typeof data === "object") {
        const msg = (data as any).message ?? (data as any).code ?? "payment_error";
        dispatch(setError(String(msg)));
      } else {
        dispatch(setError("payment_error"));
      }
    } catch (err) {
      console.debug("[ws:payment] error dispatch error", err);
    }
  }),
]);
